import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="auto-submit"
export default class extends Controller {
  static targets = ['field']

  connect () {
    console.log('Auto-submit controller connected to:', this.element)
  }

  decrement (event) {
    this.updateNumberField(event, -1)
  }

  increment (event) {
    this.updateNumberField(event, 1)
  }

  submit (event) {
    console.log('Submit triggered with value:', event.target.value)
    // Only submit if a valid option is selected (not the prompt)
    if (event.target.value && event.target.value !== '') {
      console.log('Submitting form...')
      this.element.requestSubmit()
    }
  }

  submitForm () {
    this.element.requestSubmit()
  }

  updateNumberField (event, direction) {
    event.preventDefault()

    const field = this.fieldTarget
    const min = Number.parseInt(field.min, 10)
    const max = Number.parseInt(field.max, 10)
    const value = Number.parseInt(field.value, 10)
    const nextValue = value + direction

    field.value = Math.max(min, Math.min(max, nextValue))
    this.element.requestSubmit()
  }
}
